/* Verbatim port of renderMarkdown from service/review/index.html
 * (~3262-3292) — the appendix's small markdown-to-HTML renderer for the
 * research dossier (tables, headings, bullet lists, inline bold/links;
 * fenced code blocks stripped). Doesn't read STATE — no parameterization
 * needed.
 *
 * F3: NOT converted to lit — this function never touches the DOM (no
 * `document.getElementById`/`innerHTML`), so there's no `render()` call
 * site to introduce. It stays a pure markdown-string → HTML-string
 * transform; its own `inline()` helper still runs every text run through
 * `esc()` before applying the bold/link regex substitutions, exactly as
 * before. Its one consumer (views/dossier.ts's renderDossier) is what
 * actually renders to the DOM — that's where this wave's unsafeHTML site
 * for the markdown/dossier pipeline lives (see dossier.ts).
 */
import { esc } from '../lib/format.ts';

export function renderMarkdown(mdRaw: string): string {
  let md = mdRaw.replace(/```json[\s\S]*?```/g, '').replace(/```[\s\S]*?```/g, '');
  const lines = md.split('\n');
  let html = '', i = 0;
  const inline = (s: string) => esc(s)
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\[(.+?)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>')
    .replace(/(^|[\s(])(https?:\/\/[^\s)]+)/g, '$1<a href="$2" target="_blank" rel="noopener">$2</a>');
  while (i < lines.length){
    const ln = lines[i] ?? ''; // i < lines.length — always defined
    if (/^\|(.+)\|\s*$/.test(ln) && /^\|[\s:|-]+\|\s*$/.test(lines[i+1] || '')){
      const cells = (r: string) => r.replace(/^\||\|$/g,'').split('|').map(c => c.trim());
      html += '<table><thead><tr>' + cells(ln).map(h => `<th>${inline(h)}</th>`).join('') + '</tr></thead><tbody>';
      i += 2;
      while (i < lines.length && /^\|(.+)\|\s*$/.test(lines[i] ?? '')){
        html += '<tr>' + cells(lines[i] ?? '').map(c => `<td>${inline(c)}</td>`).join('') + '</tr>'; i++;
      }
      html += '</tbody></table>'; continue;
    }
    if (/^#{1,6}\s/.test(ln)){ const lvl = Math.min(3, ln.match(/^#+/)![0].length); html += `<h${lvl}>${inline(ln.replace(/^#+\s/,''))}</h${lvl}>`; i++; continue; }
    if (/^\s*[-*]\s+/.test(ln)){
      html += '<ul>';
      while (i < lines.length && /^\s*[-*]\s+/.test(lines[i] ?? '')){ html += `<li>${inline((lines[i] ?? '').replace(/^\s*[-*]\s+/,''))}</li>`; i++; }
      html += '</ul>'; continue;
    }
    if (/^---+\s*$/.test(ln)){ i++; continue; }
    if (ln.trim() === ''){ i++; continue; }
    html += `<p>${inline(ln)}</p>`; i++;
  }
  return html;
}
